export const SET_STAT = (state, payload) => {
  state.stat = payload;
}

export const SET_MONTHLY_STATS = (state, payload) => {
  state.monthly_stats = payload;
}

export const SET_TEMPLATE_STATS = (state, payload) => {
  state.total = payload.count;
  state.template_stats = payload.results;
}